document.addEventListener('DOMContentLoaded', function() {
    initCart();
    initCylindersClick();
    if($('#sidekick_variant_id').length > 0) {
        $('.pdp-extra-product-selector').on('click', function () {

            if($('#no').is(':checked')){
                $('#info_about_sidekick').show();
                updateDefaultProductGallery(1);
            }else{
                $('#info_about_sidekick').hide();
                updateDefaultProductGallery(0);
            }
        });
    }
});

function updateDefaultProductGallery(action) {
    if(action==1){
        $('.product-variant-gallery').each(function(){
            if($(this).find('div.gallery-for-waterbox').length > 0){
                $(this).find('div.gallery-for-waterbox').show();
                $(this).find('div.gallery-without-waterbox').hide();
            }
        });
    }else{
        $('div.gallery-for-waterbox').hide();
        $('div.gallery-without-waterbox').show();
    }

    if(detectMobForGallery() == true) {
        setTimeout(function(){$('.gallery-thumbs').hide();},200);
    }
}

function selectPdpVariant(option, value) {
    let activeColorElement = document.querySelector('.variant-color.active-variant');
    let activeSizeElement = document.querySelector('.variant-size.active-variant');

    let active_color = activeColorElement ? activeColorElement.dataset.variantTitle : null;
    let active_size = activeSizeElement ? activeSizeElement.dataset.variantTitle : null;

    let productVariantOptions = document.querySelectorAll('#product_variant_id option');

    productVariantOptions.forEach(function(option) {
        let option1 = option.dataset.option1;
        let option2 = option.dataset.option2;
        let variant_price = parseInt(option.getAttribute('data-variant-price'));
        let variant_compare_price = parseInt(option.getAttribute('data-variant-compare-price'));
        let available = option.getAttribute('data-variant-available');

        let active_compare_price = 0;
        if(variant_price < variant_compare_price) {
            active_compare_price = 1;
        }

        if ((option1 === active_color && option2 === active_size)
            || (option1 === active_size && option2 === active_color)
            || (active_color==null && option1 == active_size)
            || (active_size==null && option1 == active_color)
        )
        {
            document.querySelector('#selected_variant_id').value = option.value;

            const addToCartElement = document.getElementById('add_to_cart');
            const soldOutElement = document.getElementById('sold_out');
            const soldOutNotifyAvailable = document.getElementById('notify-when-available');
            const comparePriceBlock = document.getElementById('product_compare_price_block');
            const normalPriceBlock = document.getElementById('product_normal_price_block');

            if (available == 'true') {
                addToCartElement.style.display = 'flex';
                soldOutElement.style.display = 'none';
                soldOutNotifyAvailable.style.display = 'none';
            } else {
                soldOutElement.style.display = 'flex';
                addToCartElement.style.display = 'none';
                soldOutNotifyAvailable.style.display = 'block';
            }
            if(active_compare_price == 1){
                comparePriceBlock.style.display = 'block';
                normalPriceBlock.style.display = 'none';

                document.getElementById('product_normal_price').textContent = formatProductPrice(variant_price);
                document.getElementById('product_normal_price_compare').textContent = formatProductPrice(variant_price);
                document.getElementById('product_compare_price').textContent = formatProductPrice(variant_compare_price);
            }else{
                comparePriceBlock.style.display = 'none';
                normalPriceBlock.style.display = 'block';
                document.getElementById('product_normal_price').textContent = formatProductPrice(variant_price);
                document.getElementById('product_normal_price_compare').textContent = formatProductPrice(variant_price);
            }
            document.getElementById('product_price_in_button').textContent = formatProductPrice(variant_price);

            selectImageOnGalleryForVariant(active_color);
        }
    });
}

function selectImageOnGalleryForVariant(active_color) {
    const element = document.querySelector(`.gallery-tmb[data-img-variant-option1="${active_color}"]`);
    if (element) {
        element.click();
    }
}

function updateProductQuantity(type, id) {
    let quantity = parseInt(document.getElementById('quantity_' + id).value);
    let new_quantity = quantity;
    if(type == 'plus'){
        new_quantity = quantity + 1;
    }
    if(type == 'minus'){
        if(quantity > 1) {
            new_quantity = quantity - 1;
        }
    }

    document.getElementById('quantity_' + id).value = new_quantity;
}
/* for showing small cart modal */
function showSmallCart() {
    const smallCartBlockOver = document.querySelector('.small-cart-overlay');
    const smallCartBlock = document.querySelector('.small-cart-block');

    if (smallCartBlockOver && smallCartBlock) {
        smallCartBlock.style.transition = 'right 500ms';
        smallCartBlock.style.right = '0';
        smallCartBlockOver.style.display = 'block';
        $('.small-cart-block').css('z-index', '99999999999999');
    }
    document.querySelector('body').style.overflow = 'hidden';
}
/* for closing small cart modal */
function closeSmallCart() {
    const smallCartBlockOver = document.querySelector('.small-cart-overlay');
    const smallCartBlock = document.querySelector('.small-cart-block');

    if (smallCartBlockOver && smallCartBlock) {
        smallCartBlockOver.style.display = 'none';
        smallCartBlock.style.transition = 'right 500ms';
        smallCartBlock.style.right = '-100%';
    }
    document.querySelector('body').style.overflow = 'auto'
}
/* for button quick add to cart on product grid hover */
function quickAddItemToCart(variant_id, product_id) {
    if (variant_id) {
        let data = {items: []};
        let qty = 1;
        if(enableGiftProduct == 'true') {
            if (product_id == 7497700147394) {
                let dataGiftProduct = {
                    id: giftProductId,
                    quantity: 1
                };
                data.items.push(dataGiftProduct);
            }
        }

        let dataMainProduct =   {
            id: parseInt(variant_id),
            quantity: qty
        };

        data.items.push(dataMainProduct);

        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js');
        xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

        xhr.onload = function () {
            if (xhr.status === 200) {
                initCart();
                showSmallCart();

            } else {
                const errorResponse = JSON.parse(xhr.responseText);
                alert(errorResponse.message + '\r\n' + errorResponse.description);
            }
        };

        xhr.onerror = function (error) {
            console.error('An error occurred:', error);
        };

        xhr.send(JSON.stringify(data));
    }
}

function addItemToCartOnPdp(product_id) {
    const qty = parseInt(document.getElementById(`quantity_${product_id}`).value);
    const variant_id = document.querySelector('.pdp-variant-selector input:checked').value;
    let has_sidekick = 'yes';
    let sidekick_variant_id = 0;

    if($('.pdp-extra-product-selector').length > 0) {
         has_sidekick = document.querySelector('.pdp-extra-product-selector input:checked').value;
         sidekick_variant_id = document.querySelector('#sidekick_variant_id').value;
    }


    if (variant_id && qty > 0) {
        let data = {items: []};

        if(has_sidekick == 'no') {
            let dataSidekickProduct = {
                id: sidekick_variant_id,
                quantity: 1
            }
            data.items.push(dataSidekickProduct);
        }

        if(enableGiftProduct == 'true') {
            if (product_id == 7497700147394) {
                let dataGiftProduct = {
                    id: giftProductId,
                    quantity: qty
                };
                data.items.push(dataGiftProduct);
            }
        }

        let dataMainProduct =   {
            id: parseInt(variant_id),
            quantity: qty
        };

        data.items.push(dataMainProduct);


        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js');
        xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');

        xhr.onload = function () {
            if (xhr.status === 200) {
                initCart();
                showSmallCart();

            } else {
                const errorResponse = JSON.parse(xhr.responseText);
                alert(errorResponse.message + '\r\n' + errorResponse.description);
            }
        };

        xhr.onerror = function (error) {
            console.error('An error occurred:', error);
        };

        xhr.send(JSON.stringify(data));
    }
}

async function initCart() {
    try {
        await fetch('/cart.js')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {

                let item_counts_in_cart = data.item_count;
                let text_items = '';
                if (item_counts_in_cart > 1) {
                    text_items = `${item_counts_in_cart} items`;
                } else {
                    text_items = `${item_counts_in_cart} item`;
                }

                if (item_counts_in_cart > 0) {
                    if ($('#big_cart_free_shipping').length > 0) {
                        document.getElementById('big_cart_free_shipping').style.display = 'flex';
                    }
                    document.getElementById('small_cart_count_items').style.display = 'inline';
                    document.getElementById('small_cart_count_items').innerText = text_items;
                    document.getElementById('header_cart_items_count').innerText = item_counts_in_cart;
                    document.getElementById('small_cart_count_items').style.display = 'block';
                    document.getElementById('small_cart_items').style.display = 'flex';
                    document.getElementById('small_cart_items_empty').style.display = 'none';
                    document.getElementById('small_cart_free_shipping').style.display = 'flex';
                    document.getElementById('small_cart_total_box').style.display = 'block';
                    //$('#small_cart_you_may_also_like').show();
                    $('#small_cart_main_block').addClass('cart-height');
                } else {
                    if ($('#big_cart_free_shipping').length > 0) {
                        document.getElementById('big_cart_free_shipping').style.display = 'none';
                    }
                    document.getElementById('small_cart_total_box').style.display = 'none';
                    document.getElementById('small_cart_free_shipping').style.display = 'none';
                    document.getElementById('small_cart_count_items').style.display = 'none';
                    document.getElementById('small_cart_count_items').innerText = '0 items';
                    document.getElementById('header_cart_items_count').innerText = '0';
                    document.getElementById('small_cart_count_items').style.display = 'none';
                    document.getElementById('small_cart_items').style.display = 'none';
                    document.getElementById('small_cart_items_empty').style.display = 'block';
                    //$('#small_cart_you_may_also_like').hide();
                    $('#small_cart_main_block').removeClass('cart-height');
                }
                loadCart();
            })
            .catch(error => {
                alert('Error: ' + error.message);
            });
    } catch (error) {
        console.error(error);
    }
}

async function loadCart() {
    let min_sum_free_shipping = sumForFreeShipping*100;

    await fetch('/cart.js')
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {

            let discount_enabled = 0;
            let saved_money = 0;
            let item_count = data.item_count;
            let original_total_price = formatProductPrice(data.original_total_price);
            let total_price = formatProductPrice(data.total_price);
            let total_original_price = data.total_price;
            let cart_has_subscribe_product = 0;
            let add_gift_product = 0;
            let gift_product_already_added = 0;
            let product_with_gift_in_cart = 0;

            if(data.original_total_price > data.total_price) {
                discount_enabled = 1;
                saved_money = data.original_total_price - data.total_price;
                saved_money = formatProductPrice(saved_money);
            }

            if (item_count > 0) {
                let cart_list  = [];
                let show_cylinders_alert = 0;

                for (let i = 0; i < item_count; i++) {
                    if (data.items[i] && data.items[i].id) {

                            let html = '';
                            let cartItemTemplate = smallCartItemTemplate;
                            let product_title = data.items[i].product_title;
                            let quantity = data.items[i].quantity;
                            let item_id = data.items[i].id;
                            let product_handle = data.items[i].handle;
                            let line_price = formatProductPrice(data.items[i].price);
                            let final_price = formatProductPrice(data.items[i].final_price);
                            let product_url = data.items[i].url;
                            let image_url = data.items[i].image;
                            let variants = data.items[i].variant_options;
                            let variant_title = data.items[i].variant_title;
                            let selling_plan_name = '';
                            let product_id = data.items[i].product_id;
                            let cart_key = data.items[i].key;
                            let hide_change_quantity = 0;
                            let this_is_gift_product = 0;
                            let hide_quantity = '';
                            let hide_delete = '';

                            if(cylinders_products_ids.length > 0) {
                                if(cylinders_products_ids.includes(product_id)) {
                                    show_cylinders_alert = 1;
                                }
                            }

                            /*GIFT PRODUCT CHECKING*/
                            if (enableGiftProduct == 'true') {
                                if (product_id == 7497700147394) {
                                    product_with_gift_in_cart = 1;
                                    if (gift_product_already_added == 0) {
                                        add_gift_product = 1;
                                    }
                                }
                                if (item_id == giftProductId) {
                                    this_is_gift_product = 1;
                                    gift_product_already_added = 1;
                                    add_gift_product = 0;
                                }
                            }

                            if (this_is_gift_product == 1 && product_with_gift_in_cart == 1 && data.items[i].final_price == 0) {
                                hide_change_quantity = 1;
                                hide_quantity = 'display:none';
                                hide_delete = 'display:none';
                            }

                            if (data.items[i].final_price == 0) {
                                final_price = '<span class="small-cart-old-price">' + line_price + '</span> <span class="small-cart-free-label">FREE</span>';
                            }
                            if (variant_title != null) {
                                variant_title = data.items[i].options_with_values[0].name + `: ${variant_title}`;
                            } else {
                                variant_title = '';
                            }

                            cartItemTemplate = cartItemTemplate.replace('[product_url]', product_url);
                            cartItemTemplate = cartItemTemplate.replace('[product_image]', image_url);
                            cartItemTemplate = cartItemTemplate.replace('[product_name]', product_title);
                            cartItemTemplate = cartItemTemplate.replace('[variant_name]', variant_title);
                            cartItemTemplate = cartItemTemplate.replace('[variant_id]', item_id);
                            cartItemTemplate = cartItemTemplate.replace('[variant_id_1]', item_id);
                            cartItemTemplate = cartItemTemplate.replace('[variant_id_2]', item_id);
                            cartItemTemplate = cartItemTemplate.replace('[delete_variant_id]', item_id);
                            cartItemTemplate = cartItemTemplate.replace('[product_quantity]', quantity);
                            cartItemTemplate = cartItemTemplate.replace('[price]', final_price);
                            cartItemTemplate = cartItemTemplate.replace('[quantity_variant_id]', item_id);
                            cartItemTemplate = cartItemTemplate.replace('[update_variant_id_1]', item_id);
                            cartItemTemplate = cartItemTemplate.replace('[update_variant_id_2]', item_id);
                            cartItemTemplate = cartItemTemplate.replace('[product_id]', product_id);
                            cartItemTemplate = cartItemTemplate.replace('[hide_quantity]', hide_quantity);
                            cartItemTemplate = cartItemTemplate.replace('[hide_delete]', hide_quantity);



                            let final_sale = 0;
                            fetch('/products/' + data.items[i].handle + '.js')
                                .then(response => {
                                    if (!response.ok) {
                                        throw new Error('Network response was not ok');
                                    }
                                    return response.json();
                                })
                                .then(product_data => {
                                    if (product_data.tags.includes('Final Sale')) {
                                        final_sale = 1;
                                    }
                                    if (product_data.variants.length > 0) {
                                        product_data.variants.forEach(async (pr_variant) => {
                                            if (pr_variant.id == item_id) {
                                                if (pr_variant.compare_at_price > 0) {
                                                    let old_price = formatProductPrice(pr_variant.compare_at_price);
                                                    var element = document.getElementById(`variant_price_${item_id}`);

                                                    if (element) {
                                                        element.style.color = '#E60000';

                                                        let oldPriceSpan = document.createElement('span');
                                                        oldPriceSpan.className = 'old-price-small-cart';
                                                        oldPriceSpan.textContent = old_price;

                                                        element.insertBefore(oldPriceSpan, element.firstChild);
                                                    }
                                                }
                                            }
                                        });
                                    }

                                });

                            html = cartItemTemplate;
                            cart_list.push(html);

                    }
                }

                if(show_cylinders_alert == 1) {
                    initCylindersAlert(1);
                }else{
                    initCylindersAlert(0);
                }


                if(total_original_price >= min_sum_free_shipping) {
                    if($('#big_cart_message_for_free_shipping_sum').length > 0){
                        document.getElementById('big_cart_message_for_free_shipping_sum').style.display = 'none';
                        document.getElementById('big_cart_message_for_free_shipping').style.display = 'block';
                        document.getElementById('big_cart_free_shipping_progress').style.width = '100%';
                    }
                    document.getElementById('message_for_free_shipping_sum').style.display = 'none';
                    document.getElementById('message_for_free_shipping').style.display = 'block';
                    document.getElementById('free_shipping_progress').style.width = '100%';
                }else{
                    let sum_left = formatProductPrice(min_sum_free_shipping - total_original_price);
                    document.getElementById('sum_for_free_shipping').textContent = sum_left;

                    if($('#big_cart_message_for_free_shipping_sum').length > 0){
                        document.getElementById('big_cart_message_for_free_shipping_sum').style.display = 'block';
                        document.getElementById('big_cart_message_for_free_shipping').style.display = 'none';
                        document.getElementById('big_cart_free_shipping_progress').style.width = `${total_original_price / min_sum_free_shipping * 100}%`;
                        document.getElementById('big_cart_sum_for_free_shipping').textContent = sum_left;
                    }
                    document.getElementById('message_for_free_shipping_sum').style.display = 'block';
                    document.getElementById('message_for_free_shipping').style.display = 'none';
                    document.getElementById('free_shipping_progress').style.width = `${total_original_price / min_sum_free_shipping * 100}%`;

                }


                document.getElementById('small_cart_total').textContent = total_price;
                document.getElementById('small_cart_items').innerHTML = cart_list.join('');

                initOnlyNumberInput();
            }

        })
        .catch(error => {
            alert('Error: ' + error.message);
        });

}

function closeCylindersDesc() {
    $('#cylinders_description').hide();
    $('.big-cart-overlay').hide();
}

function initCylindersClick() {
    $('.pdp-cylinders-agree-selector').on('click', function () {
        if($(this).find('input[name="cylinders-agree"]').is(':checked')){
            $(this).removeClass('not-active-agree');
            $(this).addClass('active-agree');
        }else{
            $(this).addClass('not-active-agree');
            $(this).removeClass('active-agree');
        }
    });
    $('.pdp-cylinders-agree-selector-big-cart').on('click', function () {
        if($(this).find('input[name="cylinders-agree"]').is(':checked')){
            $(this).removeClass('not-active-agree');
            $(this).addClass('active-agree');
        }else{
            $(this).addClass('not-active-agree');
            $(this).removeClass('active-agree');
        }
    });
}

function initCylindersAlert(action) {
    let agree_cylinders_alert = 0;
    let agree_big_cart_cylinders_alert = 0;
    if($('input[id="i_agree"]').is(':checked')){
        agree_cylinders_alert = 1;
    }
    if($('input[id="i_agree_big_cart"]').is(':checked')){
        agree_big_cart_cylinders_alert = 1;
    }
    if(agree_big_cart_cylinders_alert == 1) {
        $('#big_cart_go_checkout_active').show();
        $('#big_cart_go_checkout_not_active').hide();
    }else{
        $('#big_cart_go_checkout_active').hide();
        $('#big_cart_go_checkout_not_active').show();
    }
    if(agree_cylinders_alert == 1) {
        $('#small_cart_go_checkout_active').show();
        $('#small_cart_go_checkout_not_active').hide();
    }else{
        $('#small_cart_go_checkout_active').hide();
        $('#small_cart_go_checkout_not_active').show();
    }

    if(action==1){
        $('#small_cart_cylinders_alert').show();
        $('#big_cart_cylinders_alert').show();
        $('.cart-height').css('padding-bottom', '130px');
    }else{
        $('#small_cart_cylinders_alert').hide();
        $('#big_cart_cylinders_alert').hide();

        $('#small_cart_go_checkout_active').show();
        $('#small_cart_go_checkout_not_active').hide();

        $('#big_cart_go_checkout_active').show();
        $('#big_cart_go_checkout_not_active').hide();

        $('.cart-height').css('padding-bottom', '0');
    }
}

function updateProductQuantityOnCart(variant_id, type, reload_cart) {
    let current_quantity = parseInt(document.getElementById('quantity_variant_' + variant_id).value);
    let current_product_id = $('#quantity_variant_' + variant_id).data('product-id');
    let new_quantity = current_quantity;

    if(type == 'plus'){new_quantity = current_quantity + 1;}
    if(type == 'minus'){new_quantity = current_quantity - 1;}

    let dataWithGift = {};
    let data = {
        [variant_id]: new_quantity
    };

    var formData = new FormData();
    formData.append("updates["+variant_id+"]", new_quantity);

    if(enableGiftProduct == 'true') {
        if (current_product_id == 7497700147394) {
            formData.append("updates["+giftProductId+"]", new_quantity);
        }
    }

    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
    })
        .then(response => response.json())
        .then(data => {
            if(reload_cart == 1){
              setTimeout(function() {
                  document.location.reload();
              }, 500);
            }else {
                initCart();
            }
    });


}

function deleteProductFromCart(variant_id, reload_cart) {
    let data = {
        'id': variant_id,
        'quantity': 0
    };

    postAjax('/cart/change.js', data, function(data){
        if(reload_cart == 1){
            setTimeout(function() {
                document.location.reload();
            }, 500);
        }else {
            initCart();
        }
    });
}

function postAjax(url, data, success) {
    var params = typeof data == 'string' ? data : Object.keys(data).map(
        function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
    ).join('&');

    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open('POST', url);
    xhr.onreadystatechange = function() {
        if (xhr.readyState>3 && xhr.status==200) { success(xhr.responseText); }
    };
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(params);
    return xhr;
}

function formatProductPrice(product_price) {
    let money_format = '$';
    let formattedPrice = product_price/100;

    formattedPrice = formattedPrice.toLocaleString("en-US", { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });

    if(Shopify.currency.rate != 1.0) {
        formattedPrice = `${formattedPrice} ${Shopify.currency.active}`;
    }else{
        formattedPrice = `$${formattedPrice}`;
    }

    return formattedPrice;
}

function updateProductPriceDisplay(price, subscribe_plan, subscribe_price ) {
    const subscribeComparePrice = document.getElementById('subscribe_compare_price');
    const productNormalPrice = document.getElementById('product_normal_price');

    if(subscribeComparePrice != null && productNormalPrice != null) {
        if (subscribe_plan === 1) {
            subscribeComparePrice.style.display = 'inline-block';
            subscribeComparePrice.textContent = price;
            productNormalPrice.textContent = subscribe_price;
            productNormalPrice.classList.add('text-[#E60000]');
        } else {
            subscribeComparePrice.style.display = 'none';
            productNormalPrice.textContent = price;
            productNormalPrice.classList.remove('text-[#E60000]');
        }
    }
}

function detectMobForGallery() {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}